<template>
  <v-container class="mb-15" v-if="!!details">
    <v-toolbar flat>
      <v-toolbar-title><h1>Detalhes da Autorização</h1></v-toolbar-title>
      <v-spacer></v-spacer>
         <v-btn @click="close()" class="px-0" color="primary" icon depressed x-small>
          <v-icon>fa fa-reply</v-icon>
        </v-btn>
    </v-toolbar>
    <v-row class="px-3">
        <v-btn @click="getFile('req')" text color="primary">
          <v-icon small class="pr-2">fa-download</v-icon>
          Baixar solicitação do prestador
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="getFile('res')" text color="primary">
          <v-icon small class="pr-2">fa-download</v-icon>
          Baixar resposta da operadora
        </v-btn>
    </v-row>
    <v-row>
      <v-col v-if="details.ctrl_mensagem">
        <p><b>Mensagem de erro do sistema</b>
      <p class="error--text pl-4">{{details.ctrl_mensagem}}</p>
      </v-col>
    </v-row>
    <!-- <v-row>
      <v-col>

          <p><b>Data e hora da solicitação</b></p>
      </v-col>
       <v-spacer></v-spacer>
       <v-col class="text-right">

       <p>{{ details.req_datasolicitacao | formatDateTime }}</p>
       </v-col>
    </v-row>
    <v-divider></v-divider> -->
    <v-toolbar class="pt-2" height="50px" flat v-if="!!details.req_datasolicitacao">
      <v-toolbar-title
        ><p><b>Data e hora da solicitação</b></p></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-title ><p>{{ details.req_datasolicitacao | formatDateTime }}</p></v-toolbar-title
      >
    </v-toolbar>
    <v-divider v-if="!!details.req_datasolicitacao"></v-divider>
    <v-toolbar class="pt-2" height="50px" flat v-if="!!details.dom_statussolicitacao_descricao">
      <v-toolbar-title
        ><p><b>Status da solicitação</b></p></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-items flat
        ><div>
          <span class="status">{{ details.dom_statussolicitacao_descricao }}</span
          ><span><v-icon :color="statusColors[details.res_statussolicitacao]" small style="font-size:13px;">fa-circle</v-icon></span>
        </div></v-toolbar-items
      >
    </v-toolbar>
    <v-divider v-if="!!details.dom_statussolicitacao_descricao"></v-divider>
    <div v-if="details.res_statussolicitacao == 1 || details.res_statussolicitacao == 7">
      <v-toolbar class="pt-2" height="50px" flat v-if="!!details.res_autorizacao_dt">
        <v-toolbar-title
          ><p><b>Data da autorização</b></p></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-title
          ><p>
            {{ details.res_autorizacao_dt | formatDate }}
          </p></v-toolbar-title
        >
      </v-toolbar>
      <v-divider v-if="!!details.res_autorizacao_dt"></v-divider>
      <v-toolbar class="pt-2" height="50px" flat v-if="!!details.res_autorizacao_senha" >
        <v-toolbar-title
          ><p><b>Senha da autorização</b></p></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-title
          ><p>{{ details.res_autorizacao_senha }}</p></v-toolbar-title
        >
      </v-toolbar>
      <v-divider v-if="!!details.res_autorizacao_senha"></v-divider>
      <v-toolbar class="pt-2" height="50px" flat v-if="!!details.res_autorizacao_senha_dt" >
        <v-toolbar-title
          ><p><b>Validade da senha</b></p></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-title
          ><p>
            {{ details.res_autorizacao_senha_dt | formatDate }}
          </p></v-toolbar-title
        >
      </v-toolbar>
      <v-divider v-if="!!details.res_autorizacao_senha_dt"></v-divider>
    </div>
    <!-- <div v-show="details.res_statussolicitacao == 3">
      <v-toolbar class="pt-2" height="50px" flat>
        <v-toolbar-title
          ><p><b>Justificativa</b></p></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-title
          ><p>{{ details.justificativa }}</p></v-toolbar-title
        >
      </v-toolbar>
      <v-divider></v-divider>
    </div> -->
    <!-- <div v-show="details.res_statussolicitacao === 5">
      <v-toolbar class="pt-2" height="50px" flat>
        <v-toolbar-title
          ><p><b>Dados faltantes</b></p></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-title
          ><p>{{ details.dados_faltantes }}</p></v-toolbar-title
        >
      </v-toolbar>
      <v-divider></v-divider>
    </div> -->
    <div v-show="details.res_statussolicitacao == 6">
      <v-toolbar class="pt-2" height="50px" flat v-if="!!details.data_cancelamento" >
        <v-toolbar-title
          ><p><b>Data do cancelamento</b></p></v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-title
          ><p>
            {{ details.data_cancelamento | formatDate }} // FALTA
          </p></v-toolbar-title
        >
      </v-toolbar>
      <v-divider v-if="!!details.data_cancelamento"></v-divider>
    </div>
    <!-- <v-toolbar class="pt-2" height="50px" flat>
      <v-toolbar-title
        ><p><b>Atendente</b></p></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-title
        ><p>{{ details.atendente }}</p></v-toolbar-title
      >
    </v-toolbar>
    <v-divider></v-divider> -->
    <v-toolbar class="pt-2" height="50px" flat v-if="!!details.req_guiaprincipal" >
      <v-toolbar-title
        ><p><b>Número da guia principal</b></p></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-title
        ><p>{{ details.req_guiaprincipal }}</p></v-toolbar-title
      >
    </v-toolbar>
    <v-divider v-if="!!details.req_guiaprincipal"></v-divider>
    <v-toolbar class="pt-2" height="50px" flat v-if="!!details.res_guiaprestador" >
      <v-toolbar-title
        ><p><b>Número da guia do prestador</b></p></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-title
        ><p>{{ details.res_guiaprestador }}</p></v-toolbar-title
      >
    </v-toolbar>
    <v-divider v-if="!!details.res_guiaprestador"></v-divider>
    <v-toolbar class="pt-2" height="50px" flat v-if="!!details.req_benef_nome" >
      <v-toolbar-title
        ><p><b>Nome do beneficiário</b></p></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-title
        ><p>{{ details.req_benef_nome }}</p></v-toolbar-title
      >
    </v-toolbar>
    <v-divider v-if="!!details.req_benef_nome"></v-divider>
    <v-toolbar class="pt-2" height="50px" flat v-if="!!details.req_benef_carteira" >
      <v-toolbar-title
        ><p><b>Carteira do beneficiário</b></p></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-title
        ><p>{{ details.req_benef_carteira }}</p></v-toolbar-title
      >
    </v-toolbar>
    <v-divider v-if="!!details.req_benef_carteira"></v-divider>
    <v-toolbar class="pt-2" height="50px" flat v-if="!!details.operadora_id" >
      <v-toolbar-title
        ><p><b>Operadora</b></p></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-title
        ><p>{{ listOperadora[details.operadora_id] }}</p>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider v-if="!!details.operadora_id"></v-divider>
    <v-toolbar class="pt-2" height="50px" flat v-if="!!details.res_guiaoperadora" >
      <v-toolbar-title
        ><p><b>Número da guia da operadora</b></p></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-title
        ><p>{{ details.res_guiaoperadora }}</p></v-toolbar-title
      >
    </v-toolbar>
    <v-divider v-if="!!details.res_guiaoperadora"></v-divider>
    <v-toolbar class="pt-2" height="50px" flat v-if="!!details.dom_tiposolicitacao_descricao" >
      <v-toolbar-title
        ><p><b>Tipo da guia</b></p></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-toolbar-title
        ><p>{{ details.dom_tiposolicitacao_descricao }}</p></v-toolbar-title
      >
    </v-toolbar>
    <v-divider v-if="!!details.dom_tiposolicitacao_descricao"></v-divider>
    <v-row class="pa-3 align-center">
        <v-spacer></v-spacer>
         <v-btn @click="close()" class="px-0" color="primary" text>
          <v-icon small class="pr-2">fa fa-reply</v-icon>
          Fechar
        </v-btn>
        <v-spacer></v-spacer>
      </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
moment.locale('pt-BR');
export default {
    data() {
        return {
        }
    },
    filters: {
        formatDate(date) {
          return moment(date).format("L")
        },
        formatDateTime(date) {
          return moment(date).format("L")
          + " " +
          moment(date).format("LT")
        },
    },
    props: {
        close: Function,
        details: Object,
        getFile: Function,
        listOperadora: Object,
        statusColors: Object,
    },
};
</script>
<style scoped>
.status {
  font-size: 16px;
  line-height: 40px;
  margin-right: 10px;
}
</style>
